export default {
	// 接口请求地址
	httpApiUrl: process.env['VUE_APP_BASE_URL'],
	// 请求超时时间
	httpTimeout: 50000,
	// 单次最大并发量
	httpMergeNum: 5,
	// 需要重新登录的 code 码
	againLoginCode: [10021, 10020],
	// 不需要弹出 全局toast提示的 code 码
	noToastCode: [20020, 20021, 10050],
	// 是在url中去掉微信鉴权后的参数信息
	hideUrlWxAuthParams: process.env['VUE_APP_HIDE_URL_WXAUTH_PARAMS'],
	// 患者端访问url域名
	domainUrl: process.env['VUE_APP_URL'],
	// 小程序appid
	sslAppid: process.env['VUE_APP_SSL_APPID'],
	// 小程序跳转链接
	sslPath: 'pages/home/index'
}
